var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 16.5006V9.00017M9 9.00017L2.46753 5.24995M9 9.00017L15.5325 5.24995M5.625 3.20198L12.375 7.0647M8.25 16.298C8.47803 16.4297 8.7367 16.499 9 16.499C9.2633 16.499 9.52197 16.4297 9.75 16.298L15 13.2978C15.2278 13.1663 15.417 12.9772 15.5487 12.7494C15.6803 12.5217 15.7497 12.2633 15.75 12.0003V5.99992C15.7497 5.73686 15.6803 5.4785 15.5487 5.25075C15.417 5.023 15.2278 4.83388 15 4.70235L9.75 1.70217C9.52197 1.57051 9.2633 1.5012 9 1.5012C8.7367 1.5012 8.47803 1.57051 8.25 1.70217L3 4.70235C2.7722 4.83388 2.58299 5.023 2.45135 5.25075C2.31971 5.4785 2.25027 5.73686 2.25 5.99992V12.0003C2.25027 12.2633 2.31971 12.5217 2.45135 12.7494C2.58299 12.9772 2.7722 13.1663 3 13.2978L8.25 16.298Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.fdaa2c4a57b7ec2bf6c7268254496b87.svg";
export { ForwardRef as ReactComponent };